export default __webpack_public_path__ + "static/media/kendall.ab8e0d7e.jpg";